
import { defineComponent, PropType } from 'vue'

import RunDetailMixin from '~/mixins/runDetailMixin'

export default defineComponent({
  name: 'AutofixIssuesChooser',
  mixins: [RunDetailMixin],
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    checkId: {
      type: String,
      required: true
    },
    autofixableIssues: {
      type: Array as PropType<Record<string, string>[]>,
      required: true
    }
  },
  data() {
    return {
      searchedIssue: '',
      selectedValue: '',
      selectedIssues: [] as Record<string, string>[],
      selectAll: false
    }
  },
  computed: {
    selectedIssueShortcodeArray(): Array<string> {
      let shortcodeArray: Array<string> = []
      shortcodeArray = this.selectedIssues.map((issue) => {
        return issue.shortcode
      })
      return shortcodeArray
    },
    searchedIssues(): Record<string, string>[] {
      const allIssues = this.autofixableIssues || []
      const searchTerm = this.searchedIssue.toLowerCase()
      if (searchTerm) {
        const filteredList = allIssues.filter((issue) => {
          return (
            issue.title.toLowerCase().includes(searchTerm) ||
            issue.shortcode.toLowerCase().includes(searchTerm)
          )
        })
        return filteredList
      }
      return allIssues
    }
  },
  watch: {
    searchedIssues(): void {
      if (!this.searchedIssue.toLowerCase()) {
        this.selectAll = true
      }
    }
  },
  methods: {
    updateSelectAll(newVal: boolean): void {
      if (newVal) {
        this.selectedIssues = this.searchedIssues
      } else {
        this.selectedIssues = []
      }
    },
    autofixSelectedIssues(close: () => void): void {
      const { owner, provider, repo } = this.$route.params
      this.createAutofixPullRequest({
        input: {
          issues: this.selectedIssueShortcodeArray,
          checkId: this.checkId
        }
      })
        .then((response) => {
          if (close) {
            close()
          } else {
            this.$emit('close')
          }
          if (response.autofixRunId) {
            this.$router.push(`/${provider}/${owner}/${repo}/autofix/${response.autofixRunId}`)
          } else {
            this.$toast.danger(
              'An error occured while redirecting you to autofixes for selected issues.'
            )
          }
        })
        .catch(() => {
          this.$toast.danger('An error occured while creating autofixes for selected issues.')
        })
    },
    isIssueSelected(
      selectedIssues: Record<string, string>[],
      issue: Record<string, string>
    ): boolean {
      return selectedIssues.includes(issue)
    }
  }
})
